import { createApiClient, ApiClient } from '../services/ApiClient';
import { Session } from '../components/Utils';
import { RootState } from '../store';
import { findIndex, remove, isEmpty, isObject } from 'lodash';
import * as types from './ActionTypes';
import { hashHistory } from 'react-router'
import {MARK_ALL_VISITED, MARK_VISITED, SET_ERROR} from "./ActionTypes";
import {IControlError} from "../components/Controls";


let api = createApiClient();

export function requestUnchekUpdate(formId: any, valuesId: any){
    return {
        type: types.REQUEST_UNCHEK_UPDATE,
        payload:{
            formId,
            valuesId,
        }
    }
}


export function createSession(uid: string, obj: Object){
    return (dispath: any) =>{
        api.createSession(uid,obj, {
            success: (response) => {
                Session.setSession(response.id);

                dispath({type: types.CREATE_REQUEST_BEFORE, payload: null});
                dispath(fetchForm(uid,response.id));
                dispath(setFormUid(uid));
                dispath({type: types.SET_STATUS_DEFAULT, payload: 0})
            },
            error: (status, error) =>  {
                const data = JSON.parse(error);
                if(data.errorMsg){
                    dispath(openAlert(data.errorMsg))
                }else{
                    dispath(openAlert("При создании заявки произошла ошибка"))
                }
            }
        })
    }
}

export function openAlert(state){
    return {
        type: types.OPEN_MODAL,
        payload: state
    }
}

export function closeAlert() {
    return {
        type: types.CLOSE_MODAL
    }
}

export function checkedPanel(panelId:string, checked:boolean, error: IControlError | undefined){
    return (dispath: any) =>{
        dispath(setError(panelId, error));
        dispath(addValue(panelId, checked ? "1": null, false));
        dispath({
            type: types.CHECKED_PANEL,
            payload: {
                panelId,
                checked
            }
        })
    } 
}

export function loadFrom(valuesId: string, formId: string){
    return (dispath: any) =>{
        api.openForm(valuesId,formId,{
            success: (response) =>{
                Session.setSession(parseInt(valuesId));
                dispath({type: types.CREATE_REQUEST_BEFORE, payload: null});
                dispath({ type: types.OPEN_FORM, payload: response});
            }
        })
    }
}

export function fetchValues(){
    return (dispath: any) =>{
        dispath(clearValues())
        dispath({ type: types.FETCH_FORM, payload :null })

        api.getAllValues({
            success: (response) =>{
                dispath({ type: types.FETCH_VALUES, payload: response})
            }
        })
    }
}

export function redirectInLK(url:string){
    return (dispath:any) =>{
        const api = createApiClient();
        api.redirect(url);
    }
}


export function setFormUid(uid: string){
    return {
        type: types.SET_FORM_UID,
        payload : uid
    }
}

export function fetchForm(uid: string, values:number){
    return (dispath:any) => {
        
       dispath(clearValues())
       dispath({ type: types.FETCH_FORM, payload :null })
       
        var checkPanels = [];
        api.getFormByUid(uid,values,{
            success: (response) =>{
                dispath({ type: types.FETCH_FORM, payload : {...response, status:0 } });
                dispath(setSection(response.sections[0].id));
                
                hashHistory.push(`/create/${uid}/${Session.getSession()}`);
            }
        })
    }
}
export function addFile(controlid:string, value: any){
    return (dispath: any, getState:() => RootState)=>{
        const state = getState().forms;
        const result ={
            type: types.ADD_VALUE,
            payload: [...state.values ]
        };
        
        let idx = findIndex(state.values, (o:any) => 
                                            o.controlid === controlid)

        if(idx > -1 && isEmpty(value)){ //delete
            result.payload = remove(state.values, (o:any) => o.controlid !== controlid);
        }else if(idx === -1 && isEmpty(value) === false){ //create
            result.payload = [...state.values,{ controlid, value }];
        }
        else if (idx > -1 && isEmpty(value) === false){ //update
            result.payload = [...state.values];
            result.payload[idx].value = value;
        }

        dispath(result);    
    }
}

function getControlsByType(form: any, type: string){
    const result = [];
    for(let section of form.sections){
        const control = section.controls.find(t => t.type === type);
        if(control){
            result.push(control);
        }
    }
    return result;
}

function checkRecal(schema: any, controlid: string): boolean {
    const controls: any = getControlsByType(schema, 'TotalHeader');
    if(controls.length > 0){
        const totalHeader = controls[0];
        for(let el of totalHeader.elements){
            if(controlid.indexOf(el as string) === 0){
                return true;
            }
          }
    }
    return false;
}

function recaleSumGrant(schema: any, values: any, dispath: any, api: ApiClient){
    const controls: any = getControlsByType(schema, 'TotalHeader');
    const countYear = values.find(t => t.controlid === 'CountYear');

    if (controls.length > 0){
        let total: number = null;
        const totalHeader = controls[0];
        const lockControl = values.find(t => t.controlid === 'Lock');
        
        for(let control of values) {
            for(let el of totalHeader.elements){
              if(control.controlid.indexOf(el as string) === 0){
                total += parseFloat(control.value);
              }
            }
        }

        if(total && (!lockControl || lockControl.value === '0')){
            const newState = [...values];
            const sumGrantIndex =  values.findIndex(o => o.controlid === 'SumGrant'); 
            const value = countYear.value < 1 ? total.toFixed(2): ((total / 100) * 75).toFixed(2)

            if(sumGrantIndex > -1) {
                newState[sumGrantIndex].value = value;
            } else {
                newState.push({ controlid: 'SumGrant', value });
            }
            dispath({
                type: types.ADD_VALUE,
                payload: [...newState]
            });
            api.setValueSync('SumGrant', value);
            setError('SumGrant', undefined)(dispath);
        }
    }
}

function recalSumGrantDynamicGrid(schema: any, values: any, dispath: any, api: ApiClient){
    const controls: any = getControlsByType(schema, 'DynamicGridPanel');
    const countYear = values.find(t => t.controlid === 'CountYear');
    const sumGrantIndex =  values.findIndex(o => o.controlid === 'SumGrant'); 

    if(controls.length > 0){
        const newState = [...values];
        const lockControl = values.find(t => t.controlid === 'Lock');
        const stateControl = values.find(t => t.controlid === controls[0].id);

        if(stateControl){
            const valueTotal: number = stateControl.value.filter(t => t.total).reduce((s,v) => s + parseFloat(v.total),0);
            const value = countYear.value < 1 ? valueTotal.toFixed(2): ((valueTotal / 100) * 75).toFixed(2);

            if(!lockControl || lockControl.value === '0'){
                if(sumGrantIndex > -1) {
                    newState[sumGrantIndex].value = value;
                } else {
                    newState.push({ controlid: 'SumGrant', value });
                }
                dispath({
                    type: types.ADD_VALUE,
                    payload: [...newState]
                });
                api.setValueSync('SumGrant', value);
                setError('SumGrant', undefined)(dispath);
            } 
        } 
    }
}

export function recal(){
    return  (dispath: any, getState:() => RootState)=>{
        const state = getState().forms;
        const api = createApiClient(state.formUid);

        recaleSumGrant(state.form, state.values, dispath, api);
        recalSumGrantDynamicGrid(state.form, state.values, dispath, api);
    }
}

export function addValue(controlid:string, value:any, refresh: boolean){
    return (dispath: any, getState:() => RootState)=>{
        const state = getState().forms;
        const newValue = value;
        const api = createApiClient(state.formUid);
        const result ={
            type: types.ADD_VALUE,
            payload: [...state.values]
        };
        
        let idx = findIndex(state.values, (o:any) => o.controlid === controlid);
        
        if(idx > -1 && isEmpty(value)){ //delete
            result.payload = remove(state.values, (o:any) => o.controlid !== controlid);
            dispath(result);
            api.removeValue(controlid, Date.now() , {
                success: () =>{
                    if(controlid === 'SumGrant'){
                        const indexLock = result.payload.findIndex(o => o.controlid === 'Lock');
                        if(indexLock > -1){
                            result.payload[indexLock].value = '0'
                        } else {
                            result.payload.push({ controlid: 'Lock', value: '0' })
                        }
                        api.setValueSync('Lock', '0');
                    }
                    dispath(result);
                    const lock = result.payload.find(o => o.controlid === 'Lock');
                    if((!lock || lock.value === '0') && checkRecal(state.form, controlid) ){
                        recaleSumGrant(state.form, result.payload, dispath, api);

                        const controls: any = getControlsByType(state.form, 'TotalHeader');
                        if(controls.length > 0){
                            const totalHeader = controls[0];
                            let total = null;
                            for(let control of result.payload) {
                                for(let el of totalHeader.elements){
                                  if(control.controlid.indexOf(el as string) === 0){
                                    total += parseFloat(control.value);
                                  }
                                }
                            }
                           
                            if(!total){
                                api.removeValue('SumGrant', Date.now(), {
                                    success: () => {
                                        dispath({
                                            type: types.ADD_VALUE,
                                            payload: remove(result.payload, (o:any) => o.controlid !== 'SumGrant')
                                        });
                                    }
                                });   
                            }
                        }
                    }
                    if (controlid === 'generate_1') {
                        if(!lock || lock.value === '0'){
                            api.removeValue('SumGrant', Date.now(), {
                                success: () => {
                                    dispath({
                                        type: types.ADD_VALUE,
                                        payload: remove(result.payload, (o:any) => o.controlid !== 'SumGrant')
                                    });
                                }
                            })    
                        }
                    }
                    //recalSumGrantDynamicGrid(state.form, result.payload, dispath, api);
                
                    if(refresh)
                        dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1});
                }
            })
        }else if(idx === -1 && isEmpty(value) === false){ //create
            const values = [...state.values,{ controlid, value }];
            dispath({ type: types.ADD_VALUE, payload: values });
            api.setValue(controlid, newValue,{
                success: ()=>{
                    if(controlid === 'SumGrant') {
                        const indexLock = values.findIndex(o => o.controlid === 'Lock');
                        if(indexLock > -1){
                            values[indexLock].value = '1'
                        } else {
                            values.push({ controlid: 'Lock', value: '1' });
                        }
                        api.setValueSync('Lock',1);
                    }
                    
                    dispath({ type: types.ADD_VALUE, payload: values });
                    if(checkRecal(state.form, controlid))
                        recaleSumGrant(state.form, values, dispath, api);
                    if (controlid === 'generate_1')
                        recalSumGrantDynamicGrid(state.form, result.payload, dispath, api);
                
                    
                    if(refresh)
                        dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1});
                }
            })
           
        }
        else if (idx > -1 && isEmpty(value) === false){ //update
            if(isObject(newValue) || (!isObject(newValue) && state.values[idx].value != newValue)) {
                result.payload = [...state.values];
                if (result.payload[idx]) {
                    result.payload[idx].value = value;
                    dispath(result);
                }
                api.setValue(controlid, newValue, {
                    success: () => {
                        if (controlid === 'SumGrant') {
                            const indexLock = result.payload.findIndex(o => o.controlid === 'Lock');
                            if (indexLock > -1) {
                                result.payload[indexLock].value = '1'
                            } else {
                                result.payload.push({controlid: 'Lock', value: '1'});
                            }
                            api.setValueSync('Lock', 1);
                        }

                        dispath(result);
                        if (checkRecal(state.form, controlid))
                            recaleSumGrant(state.form, result.payload, dispath, api);
                        if (controlid === 'generate_1')
                            recalSumGrantDynamicGrid(state.form, result.payload, dispath, api);

                        if (refresh)
                            dispath({type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1});
                    }
                });
            }
        }        
    }
}

export function setSection(id:string){
    return {
        type: types.SET_SECTION,
        payload: {
           id
        }
    }
}

export function clearValues(){
    return {
        type: types.CLEAR_VALUES,
        payload: {}
    }
}

export function incrimentToSend(){
    return (dispath: any, getState:() => RootState) =>{
        const state = getState().forms;
       
        dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1});
    }
}



export function removeReportPdf(formId: string, valuesId: string, type?: 'one' | 'two'){
    return (dispath: any, getState:() => RootState) =>{
        const api = createApiClient();
        api.removeReportPdf({
            formId,
            valuesId,
            type,
            handlers: {
            success: ()=>{
                dispath(fetchValues());
            }
        }});
    }
}

export function copyValue(sourceId: string, targetId: string){
    return (dispath: any, getState:()=>RootState) =>{
        
        const { values, formUid } = getState().forms;
        const valueIdx = findIndex(values, (val:any) => val.controlid === sourceId);
        const api = createApiClient(formUid);

        if(valueIdx > -1){
            const value = values[valueIdx].value;
            if(isObject(value)){
                api.setValueSync(targetId, value, {
                    success: () =>{
                        dispath({ type: types.ADD_VALUE, payload: [...values,{ controlid: targetId, value }] });
                    }
                });
            }
           
        }
    }
}

export function markVisited(id: string) {
    return (dispatch: any, getState: () => RootState) => {
        dispatch({
            type: MARK_VISITED,
            payload: id
        });
    };
}

export function markAllVisited() {
    return (dispatch: any, getState: () => RootState) => {
        dispatch({
            type: MARK_ALL_VISITED,
        });
    };
}

export function setError(id: string, error: IControlError) {
    return dispatch => {
        dispatch({
            type: SET_ERROR,
            payload: {
                id,
                error
            }
        });
    };
}


// WEBPACK FOOTER //
// ./src/actions/index.ts